var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40234 8.56641C11.1182 8.56641 13.8037 5.43652 13.8037 4.47949C13.8037 3.52246 11.0938 0.397461 7.40234 0.397461C3.71582 0.397461 0.996094 3.52246 0.996094 4.47949C0.996094 5.43652 3.69141 8.56641 7.40234 8.56641ZM7.40234 8.16602C3.94043 8.16602 1.42578 5.23145 1.42578 4.47949C1.42578 3.75195 3.94043 0.788086 7.40234 0.788086C10.8594 0.788086 13.374 3.75195 13.374 4.47949C13.374 5.23145 10.8594 8.16602 7.40234 8.16602ZM7.40234 7.2041C8.89648 7.2041 10.1367 5.96387 10.1367 4.47949C10.1367 2.96094 8.89648 1.75488 7.40234 1.75488C5.88379 1.75488 4.6582 2.96094 4.66309 4.47949C4.67285 5.96387 5.88379 7.2041 7.40234 7.2041ZM7.40723 5.2998C6.94336 5.2998 6.56738 4.93359 6.56738 4.47949C6.56738 4.02051 6.94336 3.65918 7.40723 3.65918C7.86133 3.65918 8.23242 4.02051 8.23242 4.47949C8.23242 4.93359 7.86133 5.2998 7.40723 5.2998Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.f199f5bc4aa187e539dcaebd0eea2c70.svg";
export { ForwardRef as ReactComponent };